import axios from "axios";
import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";
import router from "@/router";
import ErrorAlert from "@/utility/ErrorAlert";
import SimrsNotif from "@/utils/SimrsNotif";
import ClientSystemStore from "@/store/modules/ClientSystemStore";
import { simpanPesanLogin } from "@/utils/pesanLogin";

// const API_URL = "http://10.10.187.6/test-rme/public/api/v1";
// const API_URL = 'http://10.10.187.6/rme/public/api/v1'
const API_URL = process.env.VUE_APP_API_URL;

const instance = axios.create({
  baseURL: API_URL,
  timeout: 20000,
  params: {} // do not remove this, its added to add params later in the config
});

// Add a request interceptor
instance.interceptors.request.use(
  function(config) {
    const token = userModule.token;
    // console.log("token", token);
    if (token) {
      config.headers.common["Authorization"] = "Bearer " + token;
      config.headers.common["X-Timestamp"] = Math.floor(Date.now() / 1000);
    } else {
      // Use application/x-www-form-urlencoded for login
      config.headers.common["Content-Type"] =
        "application/x-www-form-urlencoded";
    }
    return config;
  },
  function(error) {
    // Do something with request error
    // alert("login err")
    // console.log("error log on request interceptor ", error);

    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  response => response,
  error => {
    const status = error.response?.status;

    if (status === 401) {
      const sempatMasuk = userModule.isSignedIn;

      userModule.clearSession();

      const msg =
        error.response?.data?.message ??
        "Autentikasi User gagal atau sesi Anda telah habis";

      if (sempatMasuk) {
        simpanPesanLogin(msg);
      }

      router.push({ name: "Login" });
    } else if (status === 423) {
      // EMR edit-window lock (EditWindowClosedException). Tampilkan pesan ramah
      // dari backend + arahkan ke tombol "Ajukan Akses Revisi" pada banner
      // read-only halaman. Jaring pengaman untuk modul yang UI-nya belum
      // meng-inject isReadOnly.
      appModule.setLoading(false);
      const lockMsg =
        error.response?.data?.message ??
        "Data terkunci — periode 48 jam koreksi sudah berakhir. " +
          "Silakan ajukan akses revisi.";
      appModule.sendErrorAlert(lockMsg);
    } else {
      ErrorAlert.showErrorAlert(error);

      if (status === 500) {
        const notif = new SimrsNotif();

        setTimeout(() => {
          const ip = ClientSystemStore.client?.ip;

          notif.send(
            `IP: ${ip} ==> ` +
              "ERROR " +
              error.response.status +
              " : " +
              error.response.data.message,
            1800
          );
        }, 1000);
      }
    }
    // else if (dt.status == 422) {

    //   let message = "";

    //   message = join(
    //     values(
    //       mapValues(error.response.data.errors, function (val) {
    //         return join(val, "; ");
    //       })
    //     ),
    //     "; "
    //   );
    //   dt = { status: 0, err: "ERR 422 : " + error.response.data.message + " (" + message + ")" }
    //   // dt = { status: 0, err: "ERR 422 : " + error.response.data.message }
    //   appModule.sendErrorAlert(dt["err"]);
    // } else {
    //   dt = { data: dt, status: dt['status'], err: "ERR " + error.response.status + " : " + error.response.data.message }
    //   appModule.sendErrorAlert(dt["err"]);
    //   // alert(dt["err"]);
    // }

    return Promise.reject(error);
  }
);

export default {
  getAPI() {
    const url = `${API_URL}`;
    return url;
  },
  getData(endpoint) {
    let url = `${API_URL}`;
    url += endpoint;
    return instance.get(url);
  },
  getDataParam(endpoint, data) {
    let url = `${API_URL}`;
    url += endpoint;
    return instance.get(url, data);
  },
  postData(endpoint, data, config = null) {
    let url = `${API_URL}`;
    url += endpoint;
    return instance.post(url, data, config);
  },
  putData(endpoint, data, config = null) {
    let url = `${API_URL}`;
    url += endpoint;
    return instance.put(url, data, config);
  },
  deleteData(endpoint) {
    let url = `${API_URL}`;
    url += endpoint;
    return instance.delete(url);
  },
  login(endpoint, data) {
    let url = `${API_URL}`;
    url += endpoint;
    return instance.get(url, data);
  },
  deleteDataParam(endpoint, data) {
    let url = `${API_URL}`;
    url += endpoint;
    return instance.delete(url, data);
  },
  apiUrl: API_URL
};
